import { SDK_DOMAIN } from '../../constants';
import { setAddEventListener } from '../../helpers';
import { replaceRouter, routes } from '../../router';

const AccountRegiComplete = {
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">계좌 등록 완료</div>
      <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-success.png" /></div>
      <div class="c_label4_4 m_b_20 text_center">계좌 등록이 완료되었습니다.</div>
      <div class="c_label5_1 text_center">
          등록한 계좌의 은행에서 자동이체 관련<br />
          안내문자를 받으실 수 있습니다.
      </div>
      <div class="bottom_btn_wrapper">
          <button id="ok_btn" class="btn c_btn1 skin1_btn">확인</button>
      </div>
    `;
  },
  afterRender: async () => {
    setAddEventListener('ok_btn', () =>
      replaceRouter(null, null, routes.close.hashPath)
    );
    setAddEventListener('connect_pay_back_button', () =>
      replaceRouter(null, null, routes.close.hashPath)
    );
  },
};
export default AccountRegiComplete;
